"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotInfo = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpotInfo = _ref => {
  let {
    color,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M4.433 19.999c0-8.597 6.97-15.567 15.567-15.567 8.597 0 15.566 6.97 15.566 15.567 0 8.597-6.97 15.566-15.566 15.566-8.598 0-15.567-6.97-15.567-15.566ZM20 2.232c-9.813 0-17.767 7.954-17.767 17.767 0 9.812 7.954 17.766 17.767 17.766 9.812 0 17.766-7.954 17.766-17.766 0-9.813-7.954-17.767-17.766-17.767Zm-.025 13.732a2.357 2.357 0 1 0 0-4.714 2.357 2.357 0 0 0 0 4.714Zm3.351 11.593c.12-.12.239-.328.299-.507.09-.329-.18-.537-.538-.418-.121.035-.232.1-.345.165a2.76 2.76 0 0 1-1.057.372c-.329.03-.567-.149-.657-.477-.06-.24-.09-.508-.06-.747.04-.338.106-.676.173-1.014.033-.17.066-.338.096-.508.134-.776.276-1.544.418-2.313.142-.768.283-1.537.418-2.313.09-.418.149-.835.149-1.253 0-.508-.299-.746-.806-.746h-4.119c-.179 0-.358 0-.507.03-.299.06-.448.208-.478.447-.03.21.12.448.388.537.24.06.478.09.717.12.567.06.746.268.746.835 0 .045-.008.09-.015.135a.819.819 0 0 0-.015.134c-.12.672-.239 1.35-.358 2.03l-.358 2.03-.359 2.327c-.149 1.134.956 2.209 1.821 2.328.537.09 1.045.09 1.582.09 1.134 0 2.09-.478 2.865-1.284Z",
    clipRule: "evenodd"
  }));
};
exports.SpotInfo = SpotInfo;
SpotInfo.displayName = "SpotInfo";